<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>官民連携チャットルーム通報詳細</h1>
    </div>

    <!-- 内閣府承認情報 -->
    <div class="approval-information">
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="1 == reportInformation?.status.id">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">
                      {{ reportInformation?.status.name }}</label
                    >
                  </label>

                  <!-- 承認可否 -->
                  <button
                    pButton
                    type="button"
                    label="ステータス登録"
                    class="button3 approval-button"
                    (click)="openSmallApprovalDialog()"
                  ></button>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ reportInformation?.staff_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 問い合わせ区分エリア -->
    <div class="inquiry-area">
      <div class="sub-title">
        <h2>通報内容</h2>
      </div>
      <!-- 問い合わせ区分 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 問い合わせ区分 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">通報対象</td>
            <td class="item-information">
              <ng-container *ngIf="reportInformation?.target_type === '1'">スレッド</ng-container>
              <ng-container *ngIf="reportInformation?.target_type === '2'">書き込み</ng-container>
            </td>
          </tr>
          <!-- 投稿タイトル -->
          <tr class="inquiry-kbn-detail" *ngIf="reportInformation?.target_title !== ''">
            <td class="item-name">スレッドタイトル</td>
            <td class="item-information">
              {{ reportInformation?.target_title }}
            </td>
          </tr>
          <!-- 投稿内容 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">書き込み内容</td>
            <td class="item-information">
              {{ reportInformation?.target_content }}
            </td>
          </tr>
          <!-- 通報理由 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">通報理由</td>
            <td class="item-information">
              {{ reportInformation?.reason }}
            </td>
          </tr>
          <!-- 会員名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">投稿者 会員名</td>
            <td class="item-information">
              {{ reportInformation?.target_organization_name }}
            </td>
          </tr>
          <!-- 部局名/事業部名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">投稿者 部局名/事業部名</td>
            <td class="item-information">
              {{ reportInformation?.target_department_name }}
            </td>
          </tr>
          <!-- 課室名/部署名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">投稿者 課室名/部署名</td>
            <td class="item-information">
              {{ reportInformation?.target_division_name }}
            </td>
          </tr>
          <!-- 役職 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">投稿者 役職</td>
            <td class="item-information">
              {{ reportInformation?.target_jobposition_name }}
            </td>
          </tr>
          <!-- 氏名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">投稿者 氏名</td>
            <td class="item-information">
              {{ reportInformation?.target_full_name }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>通報者情報</h2>
      </div>
      <!-- 問い合わせ区分 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 会員名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">会員名</td>
            <td class="item-information">
              {{ reportInformation?.reporter_organization_name }}
            </td>
          </tr>
          <!-- 部局名/事業部名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">部局名/事業部名</td>
            <td class="item-information">
              {{ reportInformation?.reporter_department_name }}
            </td>
          </tr>
          <!-- 課室名/部署名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">課室名/部署名</td>
            <td class="item-information">
              {{ reportInformation?.reporter_division_name }}
            </td>
          </tr>
          <!-- 役職 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">役職</td>
            <td class="item-information">
              {{ reportInformation?.reporter_jobposition_name }}
            </td>
          </tr>
          <!-- 氏名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">氏名</td>
            <td class="item-information">
              {{ reportInformation?.reporter_full_name }}
            </td>
          </tr>
        </ng-template>
      </p-table>

  </div>
</div>

<!-- 共通部品_承認時ダイアログ -->
<app-approval-dialog
  (returnApproval)="getDetailInquiry()"
></app-approval-dialog>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
